export enum IntegrationId {
  discord = 1,
  slack = 2,
  chatbot = 3,
  zapier = 4,
  hubSpot = 5,
  apiIntegration = 6,
  telegram = 7,
}
